/** Labels for the campaign values (rally kinds and statuses, checklist, tour purposes, vehicles), in Hindi and English. */
import type { RallyCheck, RallyKind, RallyStatus, TourPurpose, TourStatus, TripStatus, VehicleKind } from "@npac/rules";
import type { Lang } from "../i18n";

type L = Record<Lang, string>;
const l = (hi: string, en: string): L => ({ hi, en });

export const RALLY_KIND: Record<RallyKind, L> = {
  rally: l("रैली", "Rally"),
  sabha: l("जनसभा", "Public meeting"),
  nukkad: l("नुक्कड़ सभा", "Nukkad sabha"),
  natak: l("नुक्कड़ नाटक", "Nukkad natak"),
  roadshow: l("रोड शो", "Roadshow"),
  padyatra: l("पदयात्रा", "Padyatra"),
  other: l("अन्य", "Other"),
};
export const RALLY_STATUS_L: Record<RallyStatus, L> = {
  planned: l("योजना में", "Planned"),
  permission_applied: l("अनुमति के लिए आवेदन", "Permission applied"),
  permission_ok: l("अनुमति मिली", "Permission granted"),
  done: l("हो गया", "Held"),
  cancelled: l("रद्द", "Cancelled"),
};
export const CHECK: Record<RallyCheck, L> = {
  permission: l("प्रशासन की अनुमति", "Admin permission"),
  stage: l("मंच", "Stage"),
  sound: l("साउंड / माइक", "Sound / mic"),
  chairs: l("कुर्सियाँ", "Chairs"),
  tent: l("टेंट / पंडाल", "Tent / pandal"),
  banners: l("बैनर / झंडे", "Banners / flags"),
  water: l("पानी", "Water"),
  lights: l("लाइट / जनरेटर", "Lights / generator"),
  security: l("सुरक्षा / वॉलंटियर", "Security / volunteers"),
  transport: l("लोगों के आने-जाने के वाहन", "Transport for people"),
  media: l("मीडिया / फोटो / लाइव", "Media / photo / live"),
  crowd: l("भीड़ जुटाने की ज़िम्मेदारी", "Crowd mobilisation"),
};
export const PURPOSE: Record<TourPurpose, L> = {
  door_to_door: l("घर-घर संपर्क", "Door to door"),
  meeting: l("बैठक", "Meeting"),
  sabha: l("सभा", "Public meeting"),
  padyatra: l("पैदल यात्रा", "Padyatra (walk)"),
  roadshow: l("रोड शो", "Road show"),
  religious: l("धार्मिक स्थल", "Religious place"),
  social: l("सामाजिक कार्यक्रम", "Social event"),
  grievance: l("समस्या सुनवाई", "Grievance hearing"),
  other: l("अन्य", "Other"),
};
export const TOUR_STATUS_L: Record<TourStatus, L> = {
  planned: l("तय", "Planned"),
  done: l("पहुँचे", "Done"),
  delayed: l("देरी", "Delayed"),
  skipped: l("छूटा", "Skipped"),
};
export const VEHICLE_KIND: Record<VehicleKind, L> = {
  e_rickshaw: l("ई-रिक्शा", "E-rickshaw"),
  auto: l("ऑटो", "Auto"),
  tempo: l("टेम्पो", "Tempo"),
  led_van: l("LED वैन", "LED van"),
  car: l("कार", "Car"),
  jeep: l("जीप / बोलेरो", "Jeep"),
  bike: l("बाइक", "Bike"),
  other: l("अन्य", "Other"),
};
export const TRIP_STATUS_L: Record<TripStatus, L> = {
  planned: l("तय", "Planned"),
  running: l("चल रही", "Running"),
  done: l("पूरा", "Done"),
  cancelled: l("रद्द", "Cancelled"),
};
